import { Alert, Radio } from 'antd';
import RadioGroup from 'antd/lib/radio/group';
import React from 'react';
import { ChangeCndWrapper, CnDChangeWarning } from './styled';

const getFriendlyCollectionType = (collectionDeliveryOption) => {
  switch (collectionDeliveryOption) {
    case 'Fixter':
      return 'Fixter hero';
    case 'GarageC&D':
      return 'Garage C&D';
    case 'CustomerC&D':
      return 'Customer C&D';
    default:
      return collectionDeliveryOption;
  }
};

const Warning = ({ collectionDeliveryOption, showWarning }) => {
  if (!showWarning) return null;
  return (
    <>
      <Alert
        type="warning"
        showIcon
        message={
          <>
            <span>
              Booking is currently <span>{getFriendlyCollectionType(collectionDeliveryOption)}</span>, are you
              sure you want to change this?
            </span>
            <br />
            <i>
              Reminder: <b>{getFriendlyCollectionType('GarageC&D')}</b> garages can also take{' '}
              <b>{getFriendlyCollectionType('Fixter')}</b> bookings.
            </i>
          </>
        }
      />
      <br />
    </>
  );
};

const ChangeCndOptions = ({ state, collectionDeliveryOption, onChange, isCustomerCnd }) => (
  <ChangeCndWrapper>
    <Warning
      collectionDeliveryOption={collectionDeliveryOption}
      showWarning={state.showCollectionTypeChangeWarning}
    />
    Change C&D type to:
    <RadioGroup onChange={onChange} value={state.collectionDeliveryOption}>
      <Radio value="Fixter" disabled={isCustomerCnd}>
        {getFriendlyCollectionType('Fixter')}
      </Radio>
      <Radio value="GarageC&D" disabled={isCustomerCnd}>
        {getFriendlyCollectionType('GarageC&D')}
      </Radio>
      <Radio value="CustomerC&D" disabled={false}>
        {getFriendlyCollectionType('CustomerC&D')}
      </Radio>
    </RadioGroup>
  </ChangeCndWrapper>
);

export default ChangeCndOptions;
